import {calculateTotalColumn, formatName} from "../../utils";

function getAgentPercent(hscGross) {
    if (hscGross >= 0 && hscGross <= 250000)
        return 0.5;
    if (hscGross > 250000 && hscGross <= 500000)
        return 0.55;
    if (hscGross > 500000 && hscGross <= 750000)
        return 0.6;
    if (hscGross > 750000 && hscGross <= 1000000)
        return 0.65;
    if (hscGross > 1000000)
        return 0.7;
    return 0;
}

export class HscPipelineFeesModel {
    date;
    property;
    totalFee;
    referral;
    credits;
    hscGross;
    cumulative;
    agentNet;
    hscNet;
    referredBy;

    constructor({data, previousCumulative, isTotal, year}) {
        if (isTotal) {
            this.date = null;
            this.property = `${year} TOTAL:`;
            this.totalFee = calculateTotalColumn(data, 'totalFee');
            this.referral = calculateTotalColumn(data, 'referral');
            this.credits = calculateTotalColumn(data, 'credits');
            this.hscGross = data[data.length - 1].cumulative;
            this.cumulative = data[data.length - 1].cumulative;
            this.agentNet = calculateTotalColumn(data, 'agentNet');
            this.hscNet = calculateTotalColumn(data, 'hscNet');
            this.referredBy = null;
        } else {
            this.date = data && data.CLOSE_OF_ESCROW ? data.CLOSE_OF_ESCROW : '';
            this.property = data && data.NAME ? `${data.NAME} - ${data.CITY ? data.CITY : ''}, ${data.STATE ? data.STATE : ''}` : '';
            this.totalFee = data && data.HSC_TOTAL_FEE ? data.HSC_TOTAL_FEE : 0;
            this.referral = data && data.REFERRAL ? data.REFERRAL : 0;
            this.credits = data && data.CREDITS ? data.CREDITS : 0;
            this.hscGross = data && data.HSC_LIST_FEE ? parseFloat(data.HSC_LIST_FEE) : 0;
            this.cumulative = this.hscGross ? this.hscGross + previousCumulative : 0;
            const agentPercent = getAgentPercent(this.hscGross);
            this.agentNet = this.hscGross ? this.hscGross * agentPercent : 0;
            this.hscNet = this.hscGross && this.agentNet ? this.hscGross - this.agentNet : 0;
            if (data && data.AGENT_FIRST_NAME)
                this.referredBy = formatName(data, 'AGENT_');
            else if (data && data.TEAM_FIRST_NAME)
                this.referredBy = formatName(data, 'TEAM_');
            else
                this.referredBy = '';
        }
    }
}

export class HscPipelineFeesTotals {
    title;
    totalFee;
    referral;
    credits;
    hscGross;
    cumulative;
    agentNet;
    hscNet;

    constructor({data, year, isCurrentYear, isTotal}) {
        this.title = isTotal ? 'TOTAL' : `${year} TOTAL:`;
        if (isTotal) {
            this.totalFee = calculateTotalColumn(data, 'totalFee');
            this.referral = calculateTotalColumn(data, 'referral');
            this.credits = calculateTotalColumn(data, 'credits');
            this.hscGross = calculateTotalColumn(data, 'hscGross');
            this.cumulative = calculateTotalColumn(data, 'cumulative');
            this.agentNet = calculateTotalColumn(data, 'agentNet');
            this.hscNet = calculateTotalColumn(data, 'hscNet');
        } else if (isCurrentYear) {
            const lastIndex = data.length - 1;
            this.totalFee = data[lastIndex] ? data[lastIndex].totalFee : 0;
            this.referral = data[lastIndex] ? data[lastIndex].referral : 0;
            this.credits = data[lastIndex] ? data[lastIndex].credits : 0;
            this.hscGross = data[lastIndex] ? data[lastIndex].hscGross : 0;
            this.cumulative = data[lastIndex] ? data[lastIndex].cumulative : 0;
            this.agentNet = data[lastIndex] ? data[lastIndex].agentNet : 0;
            this.hscNet = data[lastIndex] ? data[lastIndex].hscNet : 0;
        } else {
            this.totalFee = data && data.length ? calculateTotalColumn(data, 'HSC_TOTAL_FEE') : 0;
            this.referral = data && data.length ? calculateTotalColumn(data, 'REFERRAL') : 0;
            this.credits = data && data.length ? calculateTotalColumn(data, 'CREDITS') : 0;
            this.hscGross = data && data.length ? calculateTotalColumn(data, 'HSC_LIST_FEE') : 0;
            this.cumulative = this.hscGross;
            if (data && data.length)
                this.agentNet = data.reduce((accumulator, property) => {
                    const hscGrossFee = property.HSC_LIST_FEE ? parseFloat(property.HSC_LIST_FEE) : 0;
                    const agentPercent = getAgentPercent(hscGrossFee);
                    return accumulator + hscGrossFee * agentPercent;
                }, 0);
            else this.agentNet = 0;
            this.hscNet = this.hscGross && this.agentNet ? this.hscGross - this.agentNet : 0;
        }
    }
}